import axiosInstance from './AxiosInstance';

/**
 * Catálogo de tutoriais em vídeo da Central de Ajuda.
 *
 * O frontend nunca fala com o Bunny: quem lista é o backend, que guarda a chave da
 * biblioteca. Aqui chega a URL de embed já montada.
 *
 * @param {boolean} refresh força releitura no Bunny; o backend só atende para superadmin.
 */
export function getHelpTutorials(refresh = false) {
    return axiosInstance.get('help/tutorials', { params: refresh ? { refresh: true } : undefined });
}
